import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconInputForm: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconInputForm"><Path d="M10 21H8V3H10V21Z" fill="currentColor"/><Path d="M6 18H2V6H6V18Z" fill="currentColor"/><Path d="M22 18H12V6H22V18Z" fill="currentColor"/></CentralIconBase>;
});

export default IconInputForm;
